/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

/**
 * Стандартный объект ошибки
 */
export interface DefaultExceptionResponse {
  /**
   * Тип проблемы. Внутренний тип ошибки микросервиса
   * @example A5478
   */
  type: string;

  /**
   * Описание логической ошибки, возникшей в процессе работы
   * @example Некорректный формат идентификатора ресурса
   */
  title: string;

  /**
   * Код состояния HTTP ( [RFC7231], раздел 6 ) созданный исходным сервером
   * @format int32
   * @example 400
   */
  status: number;

  /**
   * Удобочитаемое объяснение проблемы
   * @example Сотрудник 9146590 не найден
   */
  detail?: string;
}

/**
 * Информация о доступном действии в UI
 */
export interface ActionInfo {
  name?: string;
  desc?: string;
  isAvailable?: boolean;
}

/**
 * Информация об адресе
 */
export interface AddressInfo {
  /** Идентификатор адреса в ФИАС */
  fiasId: string;

  /**
   * Регион (двузначный код)
   * @pattern [0-9]{2}
   * @example 66
   */
  region: string;

  /** Район */
  area?: string;

  /**
   * Индекс
   * @example 111000
   */
  index: string;

  /**
   * название города
   * @example Москва
   */
  city?: string;

  /** Тип населенного пункта */
  settlementType?: string;

  /** Название населенного пункта (если не город) */
  settlement?: string;

  /**
   * Улица
   * @example Ленина
   */
  street?: string;

  /**
   * Тип улицы
   * @example б-р
   */
  streetType?: string;

  /**
   * Дом
   * @example 2
   */
  house: string;

  /**
   * Корпус/строение
   * @example 3
   */
  housing?: string;

  /**
   * Квартира
   * @example 10
   */
  apartment?: string;

  /**
   * Адрес в одну строку
   * @example г Екатеринбург, ул Тобольская, д 67Б к 1, кв 13
   */
  value?: string;
}

/**
 * Контактная информация
 */
export interface ContactInfo {
  /**
   * Информация по карте
   * @example ivanovPES@mail.ru
   */
  email?: string;

  /**
   * Чек-бокс "СМС-информирование"
   * @example true
   */
  smsInfo: boolean;

  /**
   * мобильный телефон сотрудника
   * @example +7 999 123 45 67
   */
  tel: string;

  /**
   * домашний телефон сотрудника
   * @example +7 999 123 45 67
   */
  telHome?: string;

  /**
   * рабочий  телефон сотрудника
   * @example +7 999 123 45 67
   */
  telWork?: string;
}

/**
 * Тип и версия документа для подписания
 */
export interface DocumentType {
  /** @example SALARY_CARDS_REGISTRY */
  documentType?: string;

  /** @example Реестр на выпуск карт */
  documentDesc?: string;

  /**
   * Версия ККБ.
   * @example 1.1
   */
  documentVersion?: string;
}

/**
 * Информация о налоговом резиденте иностранного государства
 */
export interface ForeignTaxResidentInfo {
  /** Код страны налогового резиденства сотрудника */
  residenceCountryCode?: string;

  /** номер миграционной карты */
  mCardNumber?: string;

  /** серия миграционной карты */
  mCardSeries?: string;

  /** Тип миграционного документа */
  type?: string;

  /** серия миграционной документа */
  series?: string;

  /** номер миграционной документа */
  number?: string;

  /**
   * дата выдачи миграционного документа
   * @example 2021-12-21
   */
  beginDate?: string;

  /**
   * дата окончания миграционного документа
   * @example 2026-12-20
   */
  endDate?: string;

  /**
   * является налоговым резидентом США
   * @example false
   */
  usaResident?: boolean;

  /**
   * родился в США
   * @example false
   */
  usaBorn?: boolean;

  /**
   * Наличие адреса проживания и/или почтового адреса
   * @example false
   */
  usaAddress?: boolean;

  /**
   * Наличие поручения на постоянное перечисление
   * @example false
   */
  usaTransfer?: boolean;

  /** ТИН (Идентификационный номер налогоплательщика (TIN) представляет собой идентификационный номер, используемый Налоговым управлением США при администрировании соблюдения налогового законодательства. Этот номер выдается Администрацией социального обеспечения (SSA) или Налоговым управление США (IRS)) */
  tin?: string;

  /** причина отсутствия ТИН */
  reasonForNotHavingTin?: string;
}

/**
 * Информация о документе удостоверяющим личность (ДУЛ)
 */
export interface IdentityDocumentInfo {
  /**
   * Тип документа из справочника (код)
   * @example 21
   */
  type: string;

  /**
   * код страны гражданства сотрудника
   * @example 643
   */
  countryCode: string;

  /**
   * Дата выдачи ДУЛ
   * @example 1999-11-21
   */
  date: string;

  /**
   * Дата окончания ДУЛ
   * @example 2024-11-21
   */
  dateEnd?: string;

  /**
   * Серия ДУЛ
   * @example 6504
   */
  series: string;

  /**
   * Номер ДУЛ
   * @example 123456
   */
  number: string;

  /**
   * Кем выдан
   * @example УФМС МО
   */
  unit: string;

  /**
   * Код подразделения
   * @example 661-003
   */
  unitCode?: string;
}

/**
 * Информация о внешнем платеже
 */
export interface PaymentInfo {
  /**
   * Номер платежки
   * @example 123456
   */
  number?: string;

  /**
   * Дата платежа
   * @example 2023-11-21
   */
  date?: string;

  /**
   * БИК банка плательщика
   * @example 21
   */
  bankBIC?: string;

  /**
   * Название банка плательщика
   * @example 643
   */
  bankName?: string;

  /**
   * Номер счета
   * @example 410810416845546854
   */
  account?: string;

  /**
   * Назначение платежа
   * @example Зачисление комиссии за обслуживание Карт, выпускаемых работникам в реестре № {number} от {date} по договору №{contract_number} от {contract_date}.
   */
  ground?: string;
}

/**
 * Список сотрудников для выпуска карт
 */
export interface PersonInfo {
  /**
   * Внутренний дентификатор сотрудника в реестре
   * @example 51a228b0-240b-4a88-995b-fd592d81fda2
   */
  id?: string;

  /**
   * Имя сотрудника
   * @example ТАТЬЯНА
   */
  firstName: string;

  /**
   * Фамилия сотрудника
   * @example СТАХЕЕВА
   */
  lastName: string;

  /**
   * Отчество сотрудника
   * @example РАФАИЛОВНА
   */
  patronymic?: string;

  /**
   * Дата рождения сотрудника
   * @example 1991-12-16
   */
  dateBirth: string;

  /** Место рождения сотрудника (как в паспорте) */
  placeBirth: string;

  /**
   * Пол сотрудника
   * @pattern ^(SEX01|SEX02)$
   * @example SEX01
   */
  sexValue: string;

  /** Информация о документе удостоверяющим личность (ДУЛ) */
  identityDoc?: IdentityDocumentInfo;

  /** Информация об адресе */
  addressReg?: AddressInfo;

  /** Информация об адресе */
  addressFact?: AddressInfo;

  /** Контактная информация */
  contactInfo?: ContactInfo;

  /**
   * ИНН
   * @example 7703 45613278
   */
  inn?: string;

  /**
   * Полис ОМС
   * @example 1234 5678 9012 3456
   */
  oms?: string;

  /**
   * СНИЛС
   * @example 132-456-786 09
   */
  snils?: string;

  /**
   * Табельный номер сотрудника
   * @example 0123
   */
  tabelNumber?: string;

  /**
   * Бенефициарный владелец
   * @example false
   */
  beneficiaryOwner: boolean;

  /**
   * Кодовое слово
   * @example Иванова1234
   */
  phrase: string;

  /**
   * транслитерация имени для эмбоссирования на карте
   * @example CARDHOLDER
   */
  latin?: string;

  /** Информация о налоговом резиденте иностранного государства */
  foreignResidence?: ForeignTaxResidentInfo;
  taxResidentOfForeignJurisdiction?: boolean;
}

/**
 * Реестр на выпуск карт
 */
export interface RegistryInfo {
  /**
   * Идентификатор реестра
   * @example 51a228b0-240b-4a88-995b-fd592d81fda2
   */
  id?: string;

  /**
   * Идентификатор клиента (ЮЛ) в АБС ЦФТ
   * @example 9894250
   */
  clientAbsId: string;

  /**
   * ИНН клиента (ЮЛ)
   * @example 772564816248
   */
  clientINN?: string;

  /**
   * Идентификатор ЗП договора в АБС ЦФТ
   * @example 9898494
   */
  contractAbsId: string;

  /**
   * Номер ЗП договора
   * @example 233500-1888
   */
  contractNumber: string;

  /**
   * Номер реестра
   * @example 5
   */
  registryNumber?: string;

  /**
   * Дата создания реестра
   * @example 2022-12-07
   */
  registryDate: string;

  /**
   * Код типа выпускаемых карт
   * @example MRC
   */
  cardType: string;

  /**
   * Полное наименование типа выпускаемых карт
   * @example Классическая карта МИР
   */
  cardTypeDescription?: string;

  /**
   * Все сотрудники в реестре резиденты РФ
   * @example true
   */
  resident?: boolean;

  /** Список сотрудников для выпуска карт */
  clientEmployee: PersonInfo[];

  /**
   * Количество сотрудников в реестре
   * @format int32
   */
  employeesCount?: number;

  /**
   * Идентификатор платежа по оплате комиссии за выпуск карт
   * @example 719da9fc-8889-477a-89e3-10f7d8d957d4
   */
  paymentRef?: string;

  /** Информация о внешнем платеже */
  externalRef?: PaymentInfo;

  /**
   * Статус реестра
   * @example PREPARED
   */
  status?: string;

  /** Доступные операции */
  actions?: ActionInfo[];

  /** Тип и версия документа для подписания */
  documentType?: DocumentType;
}

/**
 * Запрос подсказок адреса
 */
export interface SuggestRequest {
  query?: string;

  /** @format int32 */
  count?: number;
}

/**
 * Список адресов
 */
export interface AddressListResp {
  /** Список адресов */
  suggestions?: Suggestions[];
}

/**
 * Предложенные значения адресов
 */
export interface DataFields {
  /** Регион (область) */
  region?: string;

  /** Район */
  area?: string;

  /** Город */
  city?: string;

  /** Населенный пункт */
  settlement?: string;

  /** Улица */
  street?: string;

  /** Дом */
  house?: string;

  /** Корпус/строение */
  block?: string;

  /** Квартира */
  flat?: string;

  /** Индекс */
  postal_code?: string;

  /** Тип региона (сокращенный) */
  region_type?: string;

  /** КЛАДР-код региона - из него получим двузначный код */
  region_kladr_id?: string;

  /** Тип района в регионе (сокращенный) */
  area_type?: string;

  /** Тип города (сокращенный) */
  city_type?: string;

  /** Тип населенного пункта (сокращенный) */
  settlement_type?: string;

  /** Тип улицы (сокращенный) */
  street_type?: string;

  /** Тип корпуса/строения (сокращенный) */
  block_type?: string;

  /** ФИАС-код (он же код ГАР) адреса для России. */
  fias_id?: string;

  /** Уровень детализации, до которого адрес найден в ФИАС (ГАР) */
  fias_level?: string;
}

/**
 * Предложенные значения адресов
 */
export interface Suggestions {
  /** Адрес (для отображения в инпуте) */
  value?: string;

  /** Предложенные значения адресов */
  data?: DataFields;

  /** Полный адрес в одну строку */
  unrestricted_value?: string;
}

/**
 * Реестр на выпуск карт для админки (базовая версия)
 */
export interface BaseRegistryInfo {
  /**
   * Идентификатор реестра
   * @example 51a228b0-240b-4a88-995b-fd592d81fda2
   */
  id: string;

  /**
   * Номер реестра
   * @example 5
   */
  registryNumber: string;

  /**
   * Дата создания реестра
   * @example 2022-12-07
   */
  registryDate: string;

  /**
   * Идентификатор клиента (ЮЛ) в АБС ЦФТ
   * @example 9894250
   */
  clientAbsId?: string;

  /**
   * Наименование клиента (ЮЛ)
   * @example ООО Рога и копыта
   */
  clientName?: string;

  /**
   * ИНН клиента (ЮЛ)
   * @example 772564816248
   */
  clientINN?: string;

  /**
   * Идентификатор ЗП договора в АБС ЦФТ
   * @example 9898494
   */
  contractAbsId?: string;

  /**
   * Номер ЗП договора
   * @example 233500-1888
   */
  contractNumber?: string;

  /**
   * Код типа выпускаемых карт
   * @example MRC
   */
  cardType?: string;

  /**
   * Полное наименование типа выпускаемых карт
   * @example Классическая карта МИР
   */
  cardTypeDescription?: string;

  /**
   * Код платежной системы выпускаемых карт
   * @example MIR
   */
  paymentSystemType?: string;

  /**
   * Количество сотрудников (выпускаемых карт) в реестре
   * @format int32
   */
  cardCount?: number;

  /**
   * Статус реестра
   * @example PREPARED
   */
  status?: string;

  /** Тип и версия документа для подписания */
  documentType?: DocumentType;
}

export interface SlicedRegistryListAdmin {
  data: BaseRegistryInfo[];
  hasMore?: boolean;

  /** @format int32 */
  lastUpdate?: number;

  /** @format int64 */
  totalElements?: number;
}

/**
 * Реестр на выпуск карт для админа детализированный
 */
export interface DetailRegistryInfo {
  /**
   * Идентификатор реестра
   * @example 51a228b0-240b-4a88-995b-fd592d81fda2
   */
  id: string;

  /**
   * Номер реестра
   * @example 5
   */
  registryNumber: string;

  /**
   * Дата создания реестра
   * @example 2022-12-07
   */
  registryDate: string;

  /**
   * Идентификатор клиента (ЮЛ) в АБС ЦФТ
   * @example 9894250
   */
  clientAbsId?: string;

  /**
   * Наименование клиента (ЮЛ)
   * @example ООО Рога и копыта
   */
  clientName?: string;

  /**
   * ИНН клиента (ЮЛ)
   * @example 772564816248
   */
  clientINN?: string;

  /**
   * Идентификатор ЗП договора в АБС ЦФТ
   * @example 9898494
   */
  contractAbsId?: string;

  /**
   * Номер ЗП договора
   * @example 233500-1888
   */
  contractNumber?: string;

  /**
   * Код типа выпускаемых карт
   * @example MRC
   */
  cardType?: string;

  /**
   * Полное наименование типа выпускаемых карт
   * @example Классическая карта МИР
   */
  cardTypeDescription?: string;

  /**
   * Код платежной системы выпускаемых карт
   * @example MIR
   */
  paymentSystemType?: string;

  /**
   * Количество сотрудников (выпускаемых карт) в реестре
   * @format int32
   */
  cardCount?: number;

  /**
   * Статус реестра
   * @example PREPARED
   */
  status?: string;

  /** Тип и версия документа для подписания */
  documentType?: DocumentType;

  /**
   * Все сотрудники в реестре резиденты РФ
   * @example true
   */
  resident?: boolean;

  /**
   * Название тарифного плана
   * @example зарплатный статус
   */
  tariffPlan?: string;

  /** Список сотрудников для выпуска карт */
  clientEmployee: PersonInfo[];

  /**
   * Идентификатор платежа по оплате комисси за выпуск карт
   * @example 719da9fc-8889-477a-89e3-10f7d8d957d4
   */
  paymentRef?: string;

  /** Информация о внешнем платеже */
  externalRef?: PaymentInfo;
}

/**
 * Информация о признаке резиденства США
 */
export interface UsResidenceType {
  /**
   * Код признака резиденства
   * @example usResident
   */
  code: string;

  /**
   * Описание
   * @example Налоговый резидент США
   */
  desc?: string;
}

/**
 * Список типов резиденства США
 */
export interface UsResidenceTypeListResponse {
  data: UsResidenceType[];
}

/**
 * Список типов ДУЛ
 */
export interface DocumentTypeListResponse {
  data: IdentityDocumentType[];
  hasMore?: boolean;

  /** @format int32 */
  lastUpdate?: number;

  /** @format int64 */
  totalElements?: number;
}

/**
 * Описание типов ДУЛ (документ удостоверяющим личность)
 */
export interface IdentityDocumentType {
  /**
   * код типа ДУЛ
   * @example 15
   */
  code: string;

  /**
   * Наименование ДУЛ
   * @example Разрешение на временное проживание
   */
  desc: string;

  /**
   * Подробное описание
   * @example Разрешение на временное проживание (для лиц без гражданства). Для иностранных граждан и лиц без гражданства, не имеющих документа, удостоверяющего личность
   */
  detailedDesc: string;

  /**
   * Код в АБС
   * @example PERMISSION_N
   */
  codeABS: string;
}

/**
 * Информация о стране
 */
export interface CountryInfo {
  /**
   * Идентификатор записи справочника
   * @example 28945
   */
  id: string;

  /**
   * Код значения справочника
   * @example 643
   */
  code: string;

  /**
   * Код ISO
   * @example RU
   */
  isoCode: string;

  /**
   * Двухбуквенный код страны
   * @example RU
   */
  twoLetterCode: string;

  /**
   * Описание значения справочника
   * @example RUS
   */
  desc: string;

  /**
   * Подробное описание значения справочника
   * @example РОССИЙСКАЯ ФЕДЕРАЦИЯ
   */
  detailedDesc?: string;

  /**
   * Подробное описание значения справочника на латинице
   * @example RUSSIAN FEDERATION
   */
  detailedDescLat?: string;
}

/**
 * Список стран
 */
export interface CountryListResponse {
  data: CountryInfo[];
}

export interface SlicedRegistryList {
  data: RegistryInfo[];
  hasMore?: boolean;

  /** @format int32 */
  lastUpdate?: number;

  /** @format int64 */
  totalElements?: number;
}

export interface ConfirmationTypeList {
  data: string[];
}

import { HttpClient } from "../../client";
import { ContentType, RequestParams } from "../../client/types";

/**
 * @title Зарплатный проект. Микросервис Реестр на выпуск карт
 * @version 1.0.0
 * @license Все права защищены ООО РСХБ-ИНТЕХ
 * @baseUrl https://owb-ms-prd-salary-cards.ndbo.dev.rshbdev.ru
 * @contact https://sdlc.go.rshbank.ru/jira/projects/OB_WAGE <info@rshbintech.ru> (https://sdlc.go.rshbank.ru/confluence/pages/viewpage.action?pageId=85998056)
 */
export class Api<
  SecurityDataType extends unknown
> extends HttpClient<SecurityDataType> {
  api = {
    /**
     * @description Редактирование реестра на выпуск карт
     *
     * @tags Реестр на выпуск карт
     * @name EditRegistry
     * @summary Сохранить изменения в реестре
     * @request PUT:/api/salary-cards/external/v1/registry
     */
    editRegistry: (data: RegistryInfo, params: RequestParams = {}) =>
      this.request<RegistryInfo, DefaultExceptionResponse>({
        path: `/api/salary-cards/external/v1/registry`,
        method: "PUT",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Создание нового реестра на выпуск карт
     *
     * @tags Реестр на выпуск карт
     * @name NewRegistry
     * @summary Сохранить новый реестр
     * @request POST:/api/salary-cards/external/v1/registry
     */
    newRegistry: (data: RegistryInfo, params: RequestParams = {}) =>
      this.request<RegistryInfo, DefaultExceptionResponse>({
        path: `/api/salary-cards/external/v1/registry`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Получение подсказок по адресу
     *
     * @tags Дадата, Supporting
     * @name GetAddr
     * @summary Address suggestion
     * @request POST:/api/salary-cards/external/v1/dadata/suggest
     */
    getAddr: (data: SuggestRequest, params: RequestParams = {}) =>
      this.request<AddressListResp, DefaultExceptionResponse>({
        path: `/api/salary-cards/external/v1/dadata/suggest`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Подписание, Реестр на выпуск карт
     * @name GetCcbString
     * @summary Эндпоинт для получения строки ККБ. Проксирует запрос в МС Подтверждения
     * @request GET:/api/salary-cards/external/v1/registry/{registryId}/build-ccb
     */
    getCcbString: (registryId: string, params: RequestParams = {}) =>
      this.request<string, DefaultExceptionResponse>({
        path: `/api/salary-cards/external/v1/registry/${registryId}/build-ccb`,
        method: "GET",
        ...params,
      }),

    /**
     * @description Получение детальной информации о реестре на выпуск карт
     *
     * @tags Реестр на выпуск карт
     * @name GetRegistryById
     * @summary Получить реестр
     * @request GET:/api/salary-cards/external/v1/registry/{id}
     */
    getRegistryById: (id: string, params: RequestParams = {}) =>
      this.request<RegistryInfo, DefaultExceptionResponse>({
        path: `/api/salary-cards/external/v1/registry/${id}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description Удаление реестра на выпуск карт
     *
     * @tags Реестр на выпуск карт
     * @name DeleteRegistry
     * @summary Удалить реестр
     * @request DELETE:/api/salary-cards/external/v1/registry/{id}
     */
    deleteRegistry: (id: string, params: RequestParams = {}) =>
      this.request<void, DefaultExceptionResponse>({
        path: `/api/salary-cards/external/v1/registry/${id}`,
        method: "DELETE",
        ...params,
      }),

    /**
     * @description Получение списка типов резиденства США
     *
     * @tags Справочники
     * @name GetUsResidenceMeta
     * @summary Get US residence types
     * @request GET:/api/salary-cards/external/v1/dict/us-residence-type
     */
    getUsResidenceMeta: (params: RequestParams = {}) =>
      this.request<UsResidenceTypeListResponse, DefaultExceptionResponse>({
        path: `/api/salary-cards/external/v1/dict/us-residence-type`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description Получение списка всех типов документов удостоверяющих личность (ДУЛ)
     *
     * @tags Справочники
     * @name GetDocumentTypeList
     * @summary Get identity document types list
     * @request GET:/api/salary-cards/external/v1/dict/identity-document-type
     */
    getDocumentTypeList: (params: RequestParams = {}) =>
      this.request<DocumentTypeListResponse, DefaultExceptionResponse>({
        path: `/api/salary-cards/external/v1/dict/identity-document-type`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description Получение списка стран
     *
     * @tags Справочники
     * @name GetCountryList
     * @summary Get country list
     * @request GET:/api/salary-cards/external/v1/dict/country
     */
    getCountryList: (params: RequestParams = {}) =>
      this.request<CountryListResponse, DefaultExceptionResponse>({
        path: `/api/salary-cards/external/v1/dict/country`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description Получение списка существующих реестров на выпуск карт
     *
     * @tags Реестр на выпуск карт
     * @name GetRegistryList
     * @summary Получить список реестров
     * @request GET:/api/salary-cards/external/v1/client/{clientAbsId}/contract/{contractAbsId}/registry
     */
    getRegistryList: (
      clientAbsId: string,
      contractAbsId: string,
      query?: {
        status?: string;
        beginDate?: string;
        endDate?: string;
        position?: number;
        size?: number;
      },
      params: RequestParams = {}
    ) =>
      this.request<SlicedRegistryList, DefaultExceptionResponse>({
        path: `/api/salary-cards/external/v1/client/${clientAbsId}/contract/${contractAbsId}/registry`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Получение номера для создания нового реестра на выпуск карт
     *
     * @tags Реестр на выпуск карт
     * @name GetNextRegistryNumber
     * @summary Получить следующий номер для реестра
     * @request GET:/api/salary-cards/external/v1/client/{clientAbsId}/contract/{contractAbsId}/next-registry-number
     */
    getNextRegistryNumber: (
      clientAbsId: string,
      contractAbsId: string,
      params: RequestParams = {}
    ) =>
      this.request<string, DefaultExceptionResponse>({
        path: `/api/salary-cards/external/v1/client/${clientAbsId}/contract/${contractAbsId}/next-registry-number`,
        method: "GET",
        ...params,
      }),

    /**
     * @description Получение типа подтверждения подписи для клиента (ЮЛ)
     *
     * @tags Подписание, Supporting
     * @name GetConfirmationType
     * @summary Get confirmation type for client
     * @request GET:/api/salary-cards/external/v1/client/{clientAbsId}/confirm-type
     */
    getConfirmationType: (clientAbsId: string, params: RequestParams = {}) =>
      this.request<ConfirmationTypeList, DefaultExceptionResponse>({
        path: `/api/salary-cards/external/v1/client/${clientAbsId}/confirm-type`,
        method: "GET",
        format: "json",
        ...params,
      }),
  };
}

export const api = new Api();
